export default {
  paas: 'itrigger-paas',
  tenant: 'itrigger-tenant',
  auth: 'itrigger-auth',
  cdp: 'cdp-service',
  campaignContent: 'itrigger-campaign-content',
  campaignData: 'cdp-service',
  campaignEngine: 'itrigger-campaign-engine',
  mallService: 'itrigger-mall',
  mall: 'mall-service',
  member: 'itrigger-member',
  message: 'itrigger-message-service',
  memberCoupon: 'itrigger-member-coupon',
  bff: 'itrigger-bff',
  appToBff: 'itrigger-app-2e-bff',
  loyalty: 'itrigger-loyalty-engine',
  channel: 'itrigger-sfs-channel',
  sfs: 'itrigger-sfs-product',
  goods: 'itrigger-sfs-product',
  order: 'itrigger-sfs-order',
  interaction: 'itrigger-sfs-interaction-service',
  essentialService: 'essential-service',
  member2: 'member-service'
}
